<!-- will render pages bases on stories or pages -->

@if (!!content) {
<div [appStoryblok]="get_content(content._editable)" class="bg-white">
  @for (section of content.sections; track $index) {
  @switch(section.component) {
  @case ('popup'){ <app-cms-popup [popup]="section"></app-cms-popup>}
  @case ('bar'){
  <div [appStoryblok]="get_content(section._editable)" [id]="!section.anchor ? section._uid : section.anchor">
    <app-cms-bar [bar]="section"></app-cms-bar>
  </div>
  }
  @case ('script'){ <app-cms-script [script]="section"></app-cms-script>}
  @case ('global_reference') {
  <div [appStoryblok]="get_content(section._editable)" [id]="!section.anchor ? section._uid : section.anchor">
    <app-cms-globalreference [references]="section"></app-cms-globalreference>
  </div>

  }
  @default {
  <section [appStoryblok]="get_content(section._editable)" [ngClass]="{'mt-[-10px]' : $index === 0}" [id]="!section.anchor ? section._uid : section.anchor">
    <app-cms-section [section]="section" [index]="$index"></app-cms-section>
  </section>
  }
  }
  }
</div>
}